export default __webpack_public_path__ + "static/media/featured.a6e37fda.png";